import { render, staticRenderFns } from "./ShelfDefinitions.vue?vue&type=template&id=1cec58a2&scoped=true&"
import script from "./ShelfDefinitions.vue?vue&type=script&lang=js&"
export * from "./ShelfDefinitions.vue?vue&type=script&lang=js&"
import style0 from "./ShelfDefinitions.vue?vue&type=style&index=0&id=1cec58a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cec58a2",
  null
  
)

export default component.exports